import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=cc8b3808"
import script from "./anchor.vue?vue&type=script&lang=js"
export * from "./anchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports